<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <div
                            v-if="data?.before?.giveDate"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金給付開始日
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ formatToTwDate(data?.before.giveDate) }}
                                </div>
                            </div>
                            <hr class="border-gray-100 border-dashed ">
                        </div>
                        <div
                            v-if="data?.before?.payMode"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金給付方式
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ data?.before.payMode }}
                                </div>
                            </div>
                            <hr class="border-gray-100 border-dashed ">
                        </div>
                        <div
                            v-if="data?.before?.payPeriod"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金給付期間
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ data?.before.payPeriod }}年
                                </div>
                            </div>
                            <hr class="border-gray-100 border-dashed ">
                        </div>
                        <div
                            v-if="data?.before?.pledgePeriod"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金保證期間
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ data?.before.pledgePeriod }}年
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #after>
                        <div
                            v-if="data?.after?.giveDate"
                            class="md:flex md:w-full divide-y divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金給付開始日
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ formatToTwDate(data?.after.giveDate) }}
                                </div>
                            </div>
                            <hr class="border-gray-100 border-dashed ">
                        </div>
                        <div
                            v-if="data?.after?.payMode"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金給付方式
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ data?.after.payMode }}
                                </div>
                            </div>
                            <hr class="border-gray-100 border-dashed ">
                        </div>
                        <div
                            v-if="data?.after?.payPeriod"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金給付期間
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ data?.after.payPeriod }}年
                                </div>
                            </div>
                            <hr class="border-gray-100 border-dashed ">
                        </div>
                        <div
                            v-if="data?.after?.pledgePeriod"
                            class="md:flex md:w-full divide-y md:divide-none divide-dashed"
                        >
                            <div class="flex">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5">
                                    年金保證期間
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ data?.after.pledgePeriod }}年
                                </div>
                            </div>
                        </div>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import { formatToTwDate } from '@/utils/is/dateUtils';

export default {
    name: 'ACData',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('AC');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, removeService, formatToTwDate };
    },
};
</script>
